import styled from 'styled-components'
import { Button as ButtonCL } from 'syf-component-library/ui/atoms'
import { Body } from 'syf-component-library/ui/typography'
import query from 'mediaQueries'
import { colors } from 'const/colors'

const Button = styled(ButtonCL)`
  margin: 0;
  padding: 0;
  font-weight: 400;
  &:hover {
    svg {
      fill: ${({ theme }): string => theme.cobrowse.hover};
    }
  }
`

export const Container = styled.footer`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
  padding: 24px 16px;
  background-color: ${colors.greyThirty};
  @media ${query.greaterThanMedium} {
    padding: 32px 40px 32px 32px;
  }
`

export const Text = styled.p`
  margin: 0;
  padding: 0;
  @media ${query.greaterThanMedium} {
    margin: 0 0 8px;
  }
`

export const SecureLink = styled(Button)`
  display: inline;
  color: ${({ theme }) => theme.footerLink};
`

export const LinkContainer = styled.div`
  @media ${query.greaterThanMedium} {
    display: flex;
  }
`

export const CobrowseButton = styled(Button)`
  display: flex;
  align-items: center;
  min-width: auto;
  padding: 0 8px;
  border: none;
  background: transparent;
  svg {
    fill: ${({ theme }): string => theme.cobrowse.text};
  }
  &:focus {
    outline: ${({ theme }): string => theme.focus || '-webkit-focus-ring-color'}
      auto 5px;
  }
  @media ${query.greaterThanSmall} {
    min-width: 120px;
    padding: 0;
  }
`

export const Link = styled.a`
  margin-right: 16px;
  color: ${({ theme }) => theme.footerLink};
  text-decoration: none;
  padding: 4px 0;
  display: block;
  &:hover,
  &:focus {
    text-decoration: underline;
  }
  @media ${query.greaterThanSmall} {
    display: inline-block;
    padding: 0;
  }
`

export const CardInformation = styled.div`
  display: flex;
  align-self: flex-start;
  margin: 10px 0 0 0;
  @media ${query.greaterThanSmall} {
    width: 82%;
  }
`

export const CardInformationMessage = styled(Body)`
  font-size: 10px;
  line-height: 15px;
`

export const FooterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`
